import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsFilingsHub() {
  return <SectionHub sectionPath="03-fundamentals/filings" />;
}
